import axios from "axios";

// Website und API laufen auf demselben Host: /api wird von nginx an den
// FastAPI-Dienst weitergereicht. Kein CORS, keine Host-Angabe im Bundle.
// REACT_APP_BACKEND_URL kann das für abweichende Setups überschreiben.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";

export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});
